module.exports = __webpack_public_path__ + "static/media/reset-finvaro.ce965e96.svg";